import { Avatar, Button, message, Popconfirm, Rate, Space, Table, Tabs, Form, Tooltip, Switch, Image, Modal, notification , Tag } from "antd";
import { useEffect } from "react";
import { UserOutlined } from "@ant-design/icons";
import { MdPhoneAndroid } from "react-icons/md";
import { MdEmail } from "react-icons/md";
import { FaAddressBook } from "react-icons/fa";
import { FaTransgender } from "react-icons/fa";
import { useState } from "react";
import { components, getRowClassName } from "../../utils/utils";
import { IoEye } from "react-icons/io5";
import { IoMdEyeOff } from "react-icons/io";
import IMAGES from "../../const/Image";
// import Tag from "antd";
import CustomerRequest from "./CustomerRequest";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { title } from "process";


const onChange = (key) => {
  console.log(key);
};



export const CustomerDetails = ({ customerDetails, setActiveTab }) => {

  const [details, setDetails] = useState([]);
  const navigate = useNavigate()
  return (
    <>
      <div className="viewCustomerCard">
        <div className="viewCustomerImg">
          {/* <Avatar size={120} icon={<UserOutlined />} /> */}

          <Image
            width={100}
            style={{
              "width": "178px",
              "height": "178px",
              "borderRadius": "50%"
            }}
            src={customerDetails?.profileImage || IMAGES.PlaceholderImage}
          />
        </div>
        <div>
        </div>
        <div className="viewCustomerDetails">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}>
            <div className="d-flex gap-3 align-items-center">
              <h1>{customerDetails?.name}</h1>
              {/* <Tooltip title="Edit Details">
                <span
                  className="action-icon-bg"
                  onClick={() => navigate("/customers/view-details/profile/edit")}
                >
                  <img src={IMAGES.EditIcon} alt="Edit" />
                </span>
              </Tooltip> */}
            </div>
            <div

            >
              {/* <h5 style={{ cursor: 'pointer' }} onClick={() => setActiveTab(5)
              }>Reward Points: <span>200</span></h5> */}
            </div>
          </div>


          <div
            style={{
              display: "flex",
            gap : "5rem",
              marginTop: "20px",
            }}
          >
            <div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                <MdPhoneAndroid style={{ fontSize: "20px", fill: "#b31217" }} />
                <span>{customerDetails?.mobile}</span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  marginTop: "15px",
                }}
              >
                <MdEmail style={{ fontSize: "20px", fill: "#b31217" }} />
                {/* <span>Bookmybeauty@gmail.com</span> */}
                <span>{customerDetails?.email}</span>
              </div>
            </div>

            <div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                <FaAddressBook style={{ fontSize: "20px", fill: "#b31217" }} />
                <span>

                  {customerDetails?.addresses}

                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  marginTop: "15px",
                }}
              >
                <FaTransgender style={{ fontSize: "20px", fill: "#b31217" }} />
                <span>{customerDetails?.gender === 0 ? "Male" : "Female"}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};



export const CustomerAddress = ({ customerDetails }) => {
  const [address, setAddress] = useState([]);
const navigate = useNavigate()

  const columns = [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      width: "80px",
      render: (value, item, index) => index + 1,
    },
    {
      title: "Address ID",
      dataIndex: "id",
      key: "id",
      width: "200px",
    },
    {
      title: "House No.",
      dataIndex: "houseNo",
      key: "houseNo",
      width: "300px",
    },
    {
      title: "Street",
      dataIndex: "street",
      key: "street",
      width: "300px",
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      width: "300px",
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      width: "300px",
    },
    {
      title: "Near",
      dataIndex: "near",
      key: "near",
      width: "300px",
    },
    {
      title: "Pincode",
      dataIndex: "pincode",
      key: "pincode",
      width: "300px",
    },
    {
      title: "Latitude",
      dataIndex: "latitude",
      key: "latitude",
      width: "300px",
    },
    {
      title: "Longitude",
      dataIndex: "longitude",
      key: "longitude",
      width: "300px",
    },
    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   key: "action",
    //   render: (_, record) => (
    //     <Space size="middle">
          
    //       <Tooltip title="Edit Details">
    //         <span
    //           className="action-icon-bg"
    //           onClick={() => navigate('/customers/view-details/address/edit')}
    //         >
    //           <img src={IMAGES.EditIcon} alt="Edit" />
    //         </span>
    //       </Tooltip>
         
    //     </Space>
    //   ),
    // },
  ];

  const [loading, setloading] = useState(false);

  return (
    <>
      <div>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns}
          loading={loading}
          dataSource={customerDetails}
          rowKey="id"

        />
      </div>
    </>
  );
};

// export const CustomerAppoinment = ({ customerDetails }) => {
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();


//   const columns = (navigate) => [
//     {
//       title: "S No.",
//       dataIndex: "sno",
//       key: "sno",
//       width: '60px',
//       render: (value, item, index) => index + 1,
//     },
//     {
//       title: "Appointment ID",
//       dataIndex: "appointmentID",
//       key: "appointmentID",
//       width: '200px'
//     },
//     {
//       title: "Salon Name",
//       dataIndex: "salon",
//       key: "salon",
//       width: '200px',
//       render: (text, record) => (
//         <a
//           onClick={() => navigate("/appoinments/view")}
//           style={{ color: "#1890ff", cursor: "pointer", fontSize: "17px" }}
//         >
//           {console.log(text, 'record')}
//           {text?.salonName}
//         </a>
//       ),
//     },
//     {
//       title: "Slot Details",
//       dataIndex: "services",
//       key: "services",
//       width: '200px',
//       render: (services, record) => {
//         // Check if services array exists and has at least one item with slot
//         if (!services || services.length === 0 || !services[0]?.slot) {
//           return "No appointment date";
//         }
        
//         return (
//           <div style={{ display: "flex", gap: "7px" }}>
//             <div>{services[0].slot}</div>
//           </div>
//         );
//       }
//     },

//     {
//       title: "Services",
//       dataIndex: "services",
//       key: "services",
//       width: '200px',
//       render: (services) => {
//         console.log(services, 'serviceesfsadfds')
//         if (!services || services.length === 0) {
//           return "No services"
//         }
//         const firstService = services[0].service.serviceName;
//         const remainingCount = services.length - 1;
//         return remainingCount > 0 ? `${firstService}... +${remainingCount}` : firstService;
//       }
//     },
//     {
//       title: "Visit Type",
//       dataIndex: "visitType",
//       key: "visitType",
//       width: '160px',
//       render: (services) => {
//         console.log(services, 'visit')
//         if (services === 0) return "Home ";
//         if (services === 1) return "Salon ";
//         if (services === 2) return "Both"

//       }
//     },

//     {
//       title: "Total Price",
//       dataIndex: "totalPrice",
//       key: "totalPrice",
//       width: '160px',
//       // render: (value, data) => {
//       //   const salon = data?.visitType
//       //   if (salon === 0) return "Home ";
//       //   if (salon === 1) return "Salon ";
//       //   if (salon === 2) return "Both"
//       // }
//     },
//     {
//       title: "Discounted Price",
//       dataIndex: "discountedPrice",
//       key: "discountedPrice",
//       width: '160px',
//       // render: (value, data) => {
//       //   const salon = data?.visitType
//       //   if (salon === 0) return "Home ";
//       //   if (salon === 1) return "Salon ";
//       //   if (salon === 2) return "Both"
//       // }
//     },

//     {
//       title: "Status",
//       dataIndex: "status",
//       width: 120,
//       align: "center",
//       render: (status, item) => (
//         <Switch
//           checked={status === 1}
//           checkedChildren="Approved"
//           unCheckedChildren="Cancelled"
//         />
//       ),
//     },

//     //     {
//     //   title: "Status",
//     //   dataIndex: "status",
//     //   width: 120,
//     //   align: "center",
//     //   render: (status) => (
        
//     //       status === 1 ? (
//     //               <Tag color="#87d068">Approved</Tag>
//     //             )
//     //     : (
//     //               <Tag color="#f50">Cancelled</Tag>
//     //             )
//     //   ),
//     // },

//     {
//       title: "Action",
//       dataIndex: "Action",
//       key: "Action",
//       width: '200px',
//       render: (_ , record) => (
//         <Space size="middle">
//           <Tooltip
//             title="View Details"
//             style={{ color: "red", cursor: "pointer" }}
//           >
//             <span className="action-icon-bg" onClick={() => navigate(`/appoinments/view/${record?.appointmentID}`)}>
//               <img src={IMAGES.ViewIcon} />
//             </span>
//           </Tooltip>
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <>
//       <div>
//         <Table
//           size="middle"
//           bordered
//           rowClassName={getRowClassName}
//           components={components}
//           columns={columns(navigate)}
//           loading={loading}
//           dataSource={customerDetails}
//         />
//       </div>
//     </>
//   );
// };


export const CustomerAppoinment = ({ customerDetails }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const columns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      width: '60px',
      render: (value, item, index) => index + 1,
    },
    {
      title: "Appointment ID",
      dataIndex: "appointmentID",
      key: "appointmentID",
      width: '200px'
    },
    {
      title: "Salon Name",
      dataIndex: "salon",
      key: "salon",
      width: '200px',
      render: (text, record) => (
        <a
          onClick={() => navigate("/appoinments/view")}
          style={{ color: "#1890ff", cursor: "pointer", fontSize: "17px" }}
        >
          {text?.salonName || "N/A"}
        </a>
      ),
    },
    {
      title: "Slot Details",
      dataIndex: "services",
      key: "services",
      width: '200px',
      render: (services) => {
        if (!services || services.length === 0 || !services[0]?.slot) {
          return "No appointment date";
        }
        return (
          <div style={{ display: "flex", gap: "7px" }}>
            <div>{services[0].slot}</div>
          </div>
        );
      }
    },
    {
      title: "Services",
      dataIndex: "services",
      key: "services",
      width: '200px',
      render: (services) => {
        if (!services || services.length === 0) {
          return "No services";
        }
        
        // Filter out services with null service objects
        const validServices = services.filter(s => s.service !== null);
        
        if (validServices.length === 0) {
          return "No service info";
        }
        
        const firstService = validServices[0].service?.serviceName || "Unknown service";
        const remainingCount = validServices.length - 1;
        
        return remainingCount > 0 
          ? `${firstService}... +${remainingCount}` 
          : firstService;
      }
    },
    {
      title: "Visit Type",
      dataIndex: "visitType",
      key: "visitType",
      width: '160px',
      render: (visitType) => {
        if (visitType === 0) return "Home";
        if (visitType === 1) return "Salon";
        if (visitType === 2) return "Both";
        return "N/A";
      }
    },
    {
      title: "Total Price",
      dataIndex: "totalPrice",
      key: "totalPrice",
      width: '160px',
    },
    {
      title: "Discounted Price",
      dataIndex: "discountedPrice",
      key: "discountedPrice",
      width: '160px',
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      render: (status, item) => (
        <Switch
          checked={status === 1}
          checkedChildren="Approved"
          unCheckedChildren="Cancelled"
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      width: '200px',
      render: (_ , record) => (
        <Space size="middle">
          <Tooltip
            title="View Details"
            style={{ color: "red", cursor: "pointer" }}
          >
            <span className="action-icon-bg" onClick={() => navigate(`/appoinments/view/${record?.appointmentID}`)}>
              <img src={IMAGES.ViewIcon} />
            </span>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns(navigate)}
          loading={loading}
          dataSource={customerDetails}
        />
      </div>
    </>
  );
};
export const CustomerComments = ({ customerDetails, getCustomerDetails }) => {
  const initialFilter = { page: 1, limit: 10 };
  const { confirm } = Modal;
  const [filter, setFilter] = useState(initialFilter);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [lblist, setLabList] = useState(customerDetails || []);

  const fetchCommentList = async () => {
    setLoading(true);
    try {
      const res = customerDetails;
      setLabList(res || []);
    } catch (error) {
      notification.error({ message: "Failed to fetch comments" });
    } finally {
      setLoading(false);
    }
  };


  const handleStatusChange = (checked, item) => {
    confirm({
      title: `Are you sure you want to ${checked ? "activate" : "deactivate"} this comment?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        setLoading(true);
        CustomerRequest.statusUpdate({
          status: checked ? "1" : "0",
          id: item.id,
        })
          .then((res) => {
            if (res && res.status === 200) {
              notification.success({
                message: "Status updated successfully",
              });
              getCustomerDetails();

            } else {
              notification.error({
                message: "Failed to update status",
              });
            }
          })
          .catch(() => {
            notification.error({
              message: "Failed to update status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };


  const handleDelete = (id) => {
    setLoading(true);
    CustomerRequest.deleteRating({ id })
      .then(() => {
        message.success("comment deleted successfully");
        getCustomerDetails();
      })
      .catch((error) => {
        message.error("Failed to delete comment");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const columns = [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      width: "60px",
      render: (value, item, index) => index + 1,
    },

    {
      title: "Ratings",
      dataIndex: "rating",
      key: "rating",
      render: (rating) => <Rate value={rating} disabled />,

    },
    {
      title: "Salon Name",
      dataIndex: "salon",
      key: "salon",
      render: (text, record) => (
        <span>

          {text?.salonName}

        </span>

      ),
    },
    {
      title: "User Name",
      dataIndex: "user",
      key: "user",
      render: (text, record) => (
        <span>

          {text?.userName}

        </span>
      ),
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
    },

    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      render: (is_active, item) => (
        <Switch
          checked={is_active === 1}
          checkedChildren="Approved"
          unCheckedChildren="Rejected"
          onChange={(checked) => handleStatusChange(checked, item)}

        />
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Popconfirm
            title="Delete this comment?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Delete">
              <span className="action-icon-bg">
                <img src={IMAGES.DeleteIcon} alt="Delete" />
              </span>
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];


  return (
    <>
      <Table
        size="middle"
        bordered
        rowClassName={getRowClassName}
        components={components}
        columns={columns}
        loading={loading}
        // dataSource={customerDetails}
        dataSource={customerDetails}
      />
    </>
  );
};


export const TransactionDeatils = ({ transactionDetails }) => {
  const initialFilter = { page: 1, limit: 10 };
  const { confirm } = Modal;
  const [filter, setFilter] = useState(initialFilter);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const navigate = useNavigate();
  const [labList, setLabList] = useState([]);
  // const [lblist, setLabList] = useState(transactionDetails || []);
  const [expiredCount, setExpiredCount] = useState(0);
  const [notExpiredCount, setNotExpiredCount] = useState(0);
  const [totalRewardPoints, setTotalRewardPoints] = useState(0);
  const { userId } = useParams();
  const fetchTransactionList = () => {

    setLoading(true);
    CustomerRequest.transactionList(userId)
      .then((response) => {
        const rawData = response?.data?.data || [];
        console.log(rawData)
        const transactions = rawData?.list || [];
        const expired = rawData?.expiredCount || 0;
        const notExpired = rawData?.notExpiredCount || 0;
        const totalCount = expired + notExpired;
        // const totalCount = response?.data?.total || 0;
        setLabList(transactions);
        setExpiredCount(expired);
        console.log(expired , "expired")
        setNotExpiredCount(notExpired);
        setTotalRewardPoints(totalCount);
        setTotalRecords(rawData?.totalCount || 0);
        // setTotalRecords(totalCount);
      })
      .catch((error) => {
        message.error("Failed to fetch categories.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };


  useEffect(() => {
    fetchTransactionList();
  }, [filter]);



  const labLists = [
    {
      sno: 1,
      title: "Credit",
      totalAmount: 150,
      timeStamp: "2025-01-06 10:00:00",
      expiryOn: "2025-01-06 12:00:00",
    },
    {
      sno: 1,
      title: "Credit (Pending)",
      totalAmount: 150,
      timeStamp: "2025-01-06 10:00:00", 
      expiryOn: "2025-01-06 12:00:00",
    },
    {
      sno: 2,
      title: "Debit",
      totalAmount: 200,
      timeStamp: "2025-01-06 10:00:00", 
      expiryOn: "2025-01-06 12:00:00",
    },
    {
      sno: 3,
      title: "Expired",
      totalAmount: 180,
      timeStamp: "2025-01-06 10:00:00", 
      expiryOn: "2025-01-06 12:00:00",
    },

  ];

  const columns = [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      width: "60px",
      render: (value, item, index) => index + 1,
    },

    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      // render: (rating) => <Rate value={rating} disabled />,

    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
      // render: (text, record) => (
      //   <span>

      //     {text?.salonName}

      //   </span>

      // ),
    },
    {
      title: "Created At",
      dataIndex: "timeStamp",
      key: "timeStamp",
      // render: (text, record) => (
      //   <span>

      //     {text?.userName}

      //   </span>
      // ),
    },
    {
      title: "Expiry On",
      dataIndex: "expiryOn",
      key: "expiryOn",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
    }

  ];


  return (
    <>
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "6px",
        marginTop: "15px",
      }} >
        <div>
          <h6>Active Reward Points: <span>{notExpiredCount}</span></h6>
        </div>
        <div>
          <h6>Expired Reward Points: <span>{expiredCount}</span></h6>
        </div>

        <div style={{
          marginTop: "15px",
          marginBottom: "20px",

        }}>
          <h6>Total Reward Points: <span>{totalRewardPoints}</span></h6>
        </div>
      </div>

      <Table
        size="middle"
        bordered
        rowClassName={getRowClassName}
        components={components}
        columns={columns}
        loading={loading}
        dataSource={labLists}
        pagination={{
          total: totalRecords,
          current: filter.page,
          pageSize: filter.limit,
          onChange: (page, pageSize) => {
            setFilter({ ...filter, page, limit: pageSize });
          },
        }}
      // dataSource={transactionDetails}
      />
    </>
  );
};




export const ViewCustomers = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { userId } = useParams();
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [form] = Form.useForm();
  const [customerDetails, setCustomerDetails] = useState([]);
  console.log(activeTab, 'asdfdsa')
  const getCustomerDetails = async () => {
    setLoading(true);
    try {
      const res = await CustomerRequest.customerDetail({ userId: userId });
      const customerData = res?.data?.data;

      setCustomerDetails(customerData);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (userId) getCustomerDetails();
  }, [userId, form]);
  const items = [
    {
      key: "1",
      label: "Profile",
      children: <CustomerDetails customerDetails={customerDetails?.user} setActiveTab={setActiveTab} />,
    },
    {
      key: "2",
      label: "Address",
      children: <CustomerAddress customerDetails={customerDetails?.addresses} />,
    },
    {
      key: "3",
      label: "Appoinments",
      children: <CustomerAppoinment customerDetails={customerDetails?.appointments} />,
    },
    {
      key: "4",
      label: "Comments & Ratings",
      children: <CustomerComments getCustomerDetails={getCustomerDetails} customerDetails={customerDetails?.ratings} />,
    },
    // {
    //   key: "5",
    //   label: "Transaction Details",
    //   children: <TransactionDeatils />
    // },
  ];
  return (
    <>

      <div span={24}>
        <Form.Item className=" submit-btn">
          <Space>
            <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
              <ArrowLeftOutlined />
            </Button>
          </Space>
        </Form.Item>
      </div>

      <div className="viewCustomerMoreDetails">
        <Tabs activeKey={String(activeTab)}
          onChange={(key) => setActiveTab(Number(key))}
          items={items} />
      </div>
    </>
  );
};



